const playerFooterRoutes = [
  {
    name: "Account Settings",
    key: "settings",
    route: "/account-settings",
  },
  {
    name: "Log Out",
    key: "signout",
    route: "/signout",
  },
];

export default playerFooterRoutes;
